module.exports = __webpack_public_path__ + "img/37-config-ausentes-lista.e47882e0.png";